import { ChangeDetectorRef, Component, OnInit } from '@angular/core';

import { FieldType } from '@ngx-formly/core';

import { get, set } from 'lodash-es';

import { ApiService } from '@services';

import { TaFormlyFieldConfig } from '../ta-formly-types';

import { Asset, ScannedAsset } from '@models';

const TAG = 'TaProjectSelectComponent ';

@Component({
    selector: 'app-ta-project-select',
    templateUrl: './ta-project-select.component.html',
    styleUrls: ['./ta-project-select.component.scss']
})
export class TaProjectSelectComponent extends FieldType<TaFormlyFieldConfig> implements OnInit {

    public selectedProjectId: string;
    public projects: Asset[] = [];
    public isLoading = true;

    constructor(
        private apiService: ApiService,
        private cd: ChangeDetectorRef
    ) {
        super();
    }

    async ngOnInit() {
        await this.getProjects();
        const value = get(this.model, this.key, null);
        if (value && value.length > 0) {
            this.selectedProjectId = value[0].asset_id;
            this.cd.detectChanges();
        }
    }

    private async getProjects() {
        this.isLoading = true;
        try {
            const data = await this.apiService.queryAssets('active', 'project', this.props.clientId);
            this.projects = data;
        } catch (error) {
            console.log(TAG + 'getProjects: error=', error);
        }
        this.isLoading = false;
    }

    public valueChanges(value: string) {
        if (value) {
            const project = this.projects.find(x => x.id === value);
            if (!project) {
                return;
            }

            const firstQuestion = project.sections?.[0]?.questions?.[0];
            const assetIdentifier = firstQuestion?.answer ?? project.identifiers.asset_identifier;
            const label = firstQuestion?.label ?? 'Project';
            const scannedProject: ScannedAsset = {
                asset_id: project.id,
                asset_identifier: assetIdentifier,
                label: label,
                value: label + ': ' + assetIdentifier,
                sections: [{
                    questions: project.sections?.[0]?.questions?.filter(question => question.showInList && question.answer) ?? []
                }]
            };
            set(this.model, this.key, [scannedProject]);
            this.formControl.setValue(scannedProject, { emitEvent: false });
            this.formControl.markAsDirty();
        } else {
            this.formControl.setValue(null, { emitEvent: false });
            this.formControl.markAsDirty();
            set(this.model, this.key, null);
        }
    }
}
